<template>
  <v-navigation-drawer app v-model="drawer" permanent :mini-variant.sync="drawer" right>
    <!-- expand-on-hover -->
    <v-list-item class="mt-3" style="justify-content: center;">
      <v-list-item-avatar size="40">
        <img src="@/assets/clinic-logo.png" alt="Clinic Logo" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>نواة كلينك </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <!-- Menu Items -->
    <v-list dense rounded>
      <!-- nav -->
      <template v-for="(item, j) in navItems">
        <!-- <v-list-group :key="item.title" :group="item.group" :prepend-icon="item.icon" class="submenu"
          v-if="item.subNavs"> -->
        <v-list-group :key="item.title" :group="item.group" :prepend-icon="item.icon" class="submenu"
          v-if="
            item.subNavs &&
            hasGroupPermission(item.codes)
          "> 
          <template v-slot:activator>
            <v-list-item-content class="submenu-header">
              <span>{{ item.title }}</span>

            </v-list-item-content>
          </template>
          <template v-for="(subitem, i) in item.subNavs">
            <!-- <v-list-item :key="i" :to="subitem.link"> -->
              <v-list-item :key="i" :to="subitem.link" 
                ripple v-if="$hasPermission(subitem.code)">
            
              <v-list-item-icon>
                <v-icon v-text="subitem.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content v-text="subitem.title"></v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
        <v-list-item :key="j" :to="item.link" ripple
        v-else-if="$hasPermission(item.code)">
        <!-- <v-list-item :key="j" :to="item.link"> -->
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content v-text="item.title"></v-list-item-content>
        </v-list-item>

      </template>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      sidebar: false,
    };
  },
  created() { },
  computed: {
    navItems() {
      return this.$store.state.sidebar.navItems;
    },
    drawer: {
      get() {
        return this.$store.getters["sidebar/isVisibleSideNav"];
      },
      set(value) {
        this.$store.dispatch("sidebar/setSidenavVisibility", value);
      },
    },
  },
  methods: {
    hasGroupPermission(codes) {
                let hasPermission = false;
                for (let i = 0; i < codes.length; i++) {
                    if (this.$hasPermission(codes[i])) {
                        hasPermission = true;
                        break;
                    }
                }
                return hasPermission;
            },  },
};
</script>
<style scoped>
/* new */


.v-navigation-drawer {
  border-left: 1px solid #e0e0e0;
  /* border-color: rgb(166 204 232); */
  box-shadow: rgba(205, 200, 200, 0.471) 0px 1px 4px;
  background: white;
}

.v-navigation-drawer--mini-variant .v-list-item {
  justify-content: center;
}

.v-navigation-drawer--mini-variant .v-list-item {
  justify-content: center;
}

.v-list-item--active {
  background-color: #9ced9c !important;
  color: white;

}

.submenu-header {
  font-weight: 600;
  /* color: #116aef; */
}

.submenu-header:hover {
  background-color: rgba(0, 123, 255, 0.1);
}

.submenu {
  margin-top: 5px;
}
</style>